import ServicePage from "../Common/ServicePage";

// Water Purifier Filter Replacement specific services
const filterReplacementServices = [
  { 
    id: 1, 
    name: 'Sediment Filter Replacement', 
    provider: 'AquaFilter Experts', 
    image: 'https://placehold.co/600x400?text=Sediment+Filter', 
    rating: 4.85, 
    reviews: 700, 
    price: 300, 
    category: 'Filter Replacement' 
  },
  { 
    id: 2, 
    name: 'Carbon Filter Replacement', 
    provider: 'PureWater Solutions', 
    image: 'https://placehold.co/600x400?text=Carbon+Filter', 
    rating: 4.90, 
    reviews: 600, 
    price: 500, 
    category: 'Filter Replacement' 
  },
  { 
    id: 3, 
    name: 'RO Membrane Replacement', 
    provider: 'RO Specialists', 
    image: 'https://placehold.co/600x400?text=RO+Membrane', 
    rating: 4.88, 
    reviews: 500, 
    price: 1200, 
    category: 'Membrane Replacement' 
  },
  { 
    id: 4, 
    name: 'Inline Filter Change', 
    provider: 'QuickFilter Services', 
    image: 'https://placehold.co/600x400?text=Inline+Filter', 
    rating: 4.75, 
    reviews: 450, 
    price: 200, 
    category: 'Filter Change' 
  },
  { 
    id: 5, 
    name: 'Post-Carbon Filter Change', 
    provider: 'CarbonCare Professionals', 
    image: 'https://placehold.co/600x400?text=Post+Carbon', 
    rating: 4.82, 
    reviews: 550, 
    price: 250, 
    category: 'Filter Change' 
  },
  { 
    id: 6, 
    name: 'Complete Filter Kit Replacement', 
    provider: 'AquaGuard Services', 
    image: 'https://placehold.co/600x400?text=Complete+Kit', 
    rating: 4.90, 
    reviews: 800, 
    price: 1800, 
    category: 'Full Service' 
  },
  { 
    id: 7, 
    name: 'UV Filter Replacement', 
    provider: 'UV Pure Solutions', 
    image: 'https://placehold.co/600x400?text=UV+Filter', 
    rating: 4.85, 
    reviews: 350, 
    price: 800, 
    category: 'UV System' 
  },
  { 
    id: 8, 
    name: 'TDS Controller Replacement', 
    provider: 'WaterTech Experts', 
    image: 'https://placehold.co/600x400?text=TDS+Controller', 
    rating: 4.80, 
    reviews: 300, 
    price: 600, 
    category: 'Accessories' 
  }
];

const filterReplacementCategories = ['Filter Replacement', 'Membrane Replacement', 'Filter Change', 'Full Service', 'UV System', 'Accessories'];

const packages = [
  { id: 1, title: "Sediment Filter Replacement", rating: "4.85 (700 reviews)", price: 300, originalPrice: 400, icon: "filter_alt" },
  { id: 2, title: "Carbon Filter Replacement", rating: "4.90 (600 reviews)", price: 500, originalPrice: 650, icon: "filter_alt" },
  { id: 3, title: "RO Membrane Replacement", rating: "4.88 (500 reviews)", price: 1200, originalPrice: 1400, icon: "water_drop" },
];

const miniServices = [
  { id: 101, title: "Inline Filter Change", price: 200, icon: "water_drop" },
  { id: 102, title: "Post-Carbon Filter Change", price: 250, icon: "filter_alt" },
];

export default function WaterPurifierFilterReplace() {
  return (
    <ServicePage
      serviceName="Water Purifier Filter Replacement"
      packages={packages}
      miniServices={miniServices}
      customServices={filterReplacementServices}
      customCategories={filterReplacementCategories}
      isCustomService={true}
    />
  );
}